import React from "react";

const Footer = () => {
  return <div className="py-4 text-white text-center bg-secondery "> &copy; 2024 all right reserved</div>;
};

export default Footer;
